import api from './api';

/**
 * Mediciones guardadas sobre el mapa.
 *
 * Se guardan los VÉRTICES, no el resultado: el valor se recalcula al
 * mostrarlo. Así, el día que exista la superficie real —con el modelo de
 * elevación— las mediciones viejas la ganan solas en vez de quedarse
 * congeladas con un número plano calculado hoy.
 */
export interface Medicion {
  id: string;
  tipo: 'distancia' | 'area';
  nombre: string | null;
  /** Vértices como [lat, lng] en WGS84. */
  puntos: Array<[number, number]>;
  creadoEn: string;
}

export async function getMediciones(): Promise<Medicion[]> {
  const { data } = await api.get('/measurements');
  return data;
}

export async function crearMedicion(
  tipo: 'distancia' | 'area',
  puntos: Array<[number, number]>,
  nombre?: string,
): Promise<Medicion> {
  const { data } = await api.post('/measurements', { tipo, puntos, nombre });
  return data;
}

export async function renombrarMedicion(id: string, nombre: string): Promise<void> {
  await api.patch(`/measurements/${id}`, { nombre });
}

export async function borrarMedicion(id: string): Promise<void> {
  await api.delete(`/measurements/${id}`);
}
